import { ICONS } from '@Const/common'
import Navigation from '@App/navigation'
import React, { useContext } from 'react'
import { PERMISSIONS } from '@Const/permissions'
import { NavLink } from 'react-router'
import { StoresContext } from '@App/contexts'
import PermissionCheck from '@Components/Utility/PermissionCheck'
import RequireFeatureFlag from '@Components/Utility/RequireFeatureFlag'
import ExpandableItem from '../../Sidebar/ExpandableItem'

const WorksRegistrationSubNavigation = () => {
    const { rightsholderStore, uiStore, userStore } = useContext(StoresContext)

    const currentRightsholderId = rightsholderStore.currentRightsholderId

    return (
        <>
            {(!rightsholderStore.isRestricted || userStore.isInternal) && (
                <PermissionCheck
                    requiredPermissions={[
                        PERMISSIONS.CATALOG_PERMISSIONS.view_works,
                        PERMISSIONS.CATALOG_PERMISSIONS.manage_works,
                        PERMISSIONS.CATALOG_PERMISSIONS.view_work_registration_status,
                    ]}
                >
                    <ExpandableItem heading="Works Registration" icon={ICONS.writeIcon}>
                        <PermissionCheck requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_works]}>
                            <NavLink to={Navigation.rightholder.matchClaim.claim(currentRightsholderId)}>
                                Claiming Tool
                            </NavLink>
                        </PermissionCheck>
                        <PermissionCheck requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_works]}>
                            <NavLink to={Navigation.rightholder.createWork.root(currentRightsholderId)}>
                                Individual Registration Tool
                            </NavLink>
                        </PermissionCheck>
                        {uiStore.isMobile ? null : (
                            <PermissionCheck requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_works]}>
                                <NavLink to={Navigation.rightholder.createWork.bulk.root(currentRightsholderId)}>
                                    Bulk Registration Tool
                                </NavLink>
                            </PermissionCheck>
                        )}
                        <PermissionCheck requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_works]}>
                            <NavLink to={Navigation.rightholder.registrationDrafts.root(currentRightsholderId)}>
                                Registration Drafts
                            </NavLink>
                        </PermissionCheck>
                        <PermissionCheck
                            requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_work_registration_status]}
                        >
                            <NavLink to={Navigation.rightholder.registrationHistory.root(currentRightsholderId)}>
                                Registration History
                            </NavLink>
                        </PermissionCheck>
                        {/* TODO change this once I know what permissions are wanted here */}
                        <PermissionCheck
                            requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.view_work_registration_status]}
                        >
                            <RequireFeatureFlag flagKey="work-merge-tool">
                                <NavLink to={Navigation.rightholder.workMerge.root(currentRightsholderId)}>
                                    Work Merge Tool
                                </NavLink>
                            </RequireFeatureFlag>
                        </PermissionCheck>
                        <PermissionCheck
                            requiredPermissions={[PERMISSIONS.CATALOG_PERMISSIONS.manage_works]}
                            orIsInternal
                        >
                            <NavLink
                                to={Navigation.rightholder.overclaim.root(rightsholderStore.currentRightsholderId)}
                            >
                                Overclaims Tool
                            </NavLink>
                        </PermissionCheck>
                    </ExpandableItem>
                </PermissionCheck>
            )}
        </>
    )
}

export default WorksRegistrationSubNavigation
